<script>
  export default {
    props: {
      content: Object,
      scopeId: String
    },
    render() {
      return this.content
    }
  }
</script>